module.exports = __webpack_public_path__ + "img/交易侠@2x.2bea7330.png";